export default __webpack_public_path__ + "static/media/logo-4-white-blue.15afbabf.svg";